import { useUser } from '@/pages/enterprise/user-provider'
import InfoField from '../info-field'
import { format, fromUnixTime } from 'date-fns'
import { siteConfig } from '@/config/site'

export default function PaymentCurrentPlan() {
  const { paymentCurrentPlan } = useUser()
  if (!paymentCurrentPlan) return

  return (
    <div className="mx-auto w-full gap-4 flex flex-col">
      <div className="flex flex-row gap-4 justify-between">
        <h2 className="text-2xl font-bold ">Current Plan</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 text-sm">
        <InfoField
          label="Amount Due"
          value={formatCurrency(
            paymentCurrentPlan.amount,
            paymentCurrentPlan.currency
          )}
        />
        <InfoField
          label="Next Payment Due Date"
          value={formatDate(paymentCurrentPlan.next_payment_date)}
        />
      </div>
    </div>
  )
}

const formatCurrency = (amount: number, currency: string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount)
}

const formatDate = (timestamp: number) => {
  const date = fromUnixTime(timestamp)
  const formattedDate = format(date, siteConfig.dateFormat)
  return formattedDate
}
